import {
	initSessionRecorder,
	getSessionRecorder,
	startOnDemandRecording,
	stopSessionRecorder,
	discardSessionRecording,
	isSessionRecording,
	isOnDemandRecordingHost
} from './SessionRecorderInit';

// Remembered so a recording started AFTER login (e.g. via the on-demand button)
// still gets the user attached, even though setUserID ran while recording was off.
let lastUserId: string | undefined;

export const tracker = {
	start() {
		initSessionRecorder(lastUserId);
	},
	/**
	 * Turn recording on for the current tab, bypassing the auto-start gate.
	 * Only takes effect on the on-demand host; a no-op everywhere else.
	 */
	startOnDemand() {
		return startOnDemandRecording(lastUserId);
	},
	stop() {
		stopSessionRecorder();
	},
	/**
	 * Cancel the current recording: stop without a final flush and delete the
	 * session on the collector so nothing is kept. On-demand host only.
	 */
	cancel() {
		discardSessionRecording();
	},
	isRecording(): boolean {
		return isSessionRecording();
	},
	/** True on the host where recording is manual (the Record button is shown). */
	isOnDemandHost(): boolean {
		return isOnDemandRecordingHost();
	},
	setUserID(userId: string) {
		lastUserId = userId;
		const recorder = getSessionRecorder();
		if (recorder) {
			recorder.setUserId(userId);
		}
	},
	/**
	 * Emit a custom business event (Subject_Verb tag) into the session.
	 * Safe no-op when recording is disabled or not yet initialized — the
	 * underlying recorder is null on dev hosts, so callers never need to guard.
	 */
	event(tag: string, payload?: unknown, options?: { color?: string }) {
		const recorder = getSessionRecorder();
		if (recorder) {
			recorder.addCustomEvent(tag, payload, options);
		}
	}
};
